
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'oxd-form-actions',

  computed: {
    classes() {
      return {
        'oxd-form-actions': true,
      };
    },
  },
});
